import React, { useState, useEffect } from "react";

import Header from "../components/header";
import markersection from "../assets/weddingcards/1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import img1 from "../assets/weddingcards/66.webp";
import img2 from "../assets/weddingcards/2.png";
import img3 from "../assets/weddingcards/3.png";
import img4 from "../assets/promotionmaker/2.png";
import img5 from "../assets/promotionmaker/3.png";
import img6 from "../assets/promotionmaker/3.png";
import img32 from "../assets/weddingcards/32.webp";
import img33 from "../assets/weddingcards/33.webp";
import img66  from "../assets/weddingcards/66.webp";

import img7 from "../assets/promotionmaker/6.webp";
import img8 from "../assets/promotionmaker/7.webp";
import img9 from "../assets/promotionmaker/8.webp";

import Button from "@mui/material/Button";
import axios from "axios";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";

import { NavLink } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import apiConfig from '../config/api.js';

const Weddingcards = () => {
  const [data, setData] = useState([]);
  const [img, setImg] = useState(`${img1}`);
  const isLang = useSelector((state) => state.authReducer.lang);
  // Function
  const [menu, setMenu] = useState("");
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  // Function

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(false);
  };
  const handelOpenModel = () => {
    dispatch(loginModal(false));
    setOpenModel(true);
  };
  const handleClose = () => {
    dispatch(loginModal(false));
    dispatch(loginModal(false));
  };
  const handleCloseModel = () => setOpenModel(false);
  const [openModel, setOpenModel] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.API_URL}/aapi/tempbycat.php?title=Wedding Cards`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("data-=-=-=-", data);
  return (
    <>
      <Header menu={menu} setMenu={setMenu} />
      <div onMouseOver={() => handleMouseOver("")} className="text-black"></div>
      <div className="pt-20 bg-purple-500">
      <div className="grid grid-cols-2 p-5">
  <div className="p-10 ml-5 text-white text-[16px] font-[100px]" style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
    {isLang === 'eng' ? (
      <>
        <p className="text-4xl font-semibold">Make a Lasting Impression with our Wedding cards</p>
        <br />
        <p style={{ fontSize: "16px" }}>
          Every wedding celebrates the uniting of two people's lives and is
          the crowning achievement of a lovely tale. Making your wedding
          invitations allows you to convey your tale in a style that is as
          distinctive as you are.
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          With the help of Maker4U wedding card templates, you may tell your
          loved ones how happy you are. You can easily design wedding
          invitations, putting the creative power in your hands. Our time-
          and effort-saving, user-friendly tools let you relax and take
          greater pleasure in the planning process.
        </p>
        <br />
      </>
    ) : (
      <>
        <p className="text-4xl font-semibold">اترك انطباعًا دائمًا مع بطاقات الزفاف الخاصة بنا</p>
        <br />
        <p style={{ fontSize: "16px" }}>
          يحتفل كل حفل زواج بتوحيد حياة شخصين، وهو تتويج لقصة جميلة. إعداد دعوات الزفاف الخاصة بك يتيح لك نقل قصتك بأسلوب متميز مثلك تمامًا.
        </p>
        <br />
        <p style={{ fontSize: "16px" }}>
          بمساعدة نماذج بطاقات زفاف Maker4U، يمكنك وصف مدى سعادتك لأحبائك. يمكنك تصميم دعوات الزفاف بسهولة، مما يضع القوة الإبداعية بين يديك. مع أدواتنا سهلة الاستخدام والموفرة للوقت والجهد يمكنك الاسترخاء والاستمتاع بشكل أكبر بعملية تخطيط الحفل.
        </p>
        <br />
      </>
    )}
  </div>

  <div>
    <LazyLoadImage src="/assets/image3.png" className="w-full h-full px-4" />
  </div>
</div>

      </div>
      <div className="text-center mt-10">
  <p className="text-[32px] font-[500]">
    {isLang === 'eng' ? (
      'Choose from beautiful free wedding invitation templates'
    ) : (
      'اختر من بين نماذج دعوة الزفاف المجانية'
    )}
  </p>

  <div className="flex justify-center mt-4">
    <div className="text-center py-4" style={{ maxWidth: "840px", textAlign: isLang === 'eng' ? 'center' : 'right' }}>
      <p style={{ fontFamily: "poppins", fontSize: "16px" }}>
        {isLang === 'eng' ? (
          'Creating your invites ought to be enjoyable and stress-free. We have produced several free pre-made wedding card templates that are simple to use and can be altered to fit your theme and style to assist you with this aspect of the preparation process.'
        ) : (
          'من المهم أن يكون إنشاء دعواتك ممتعًا وخاليًا من التوتر. لقد أنتجنا العديد من نماذج بطاقات الزفاف المجانية المعدة مسبقًا والتي تتميز بسهولة الاستخدام ويمكن تعديلها لتناسب سماتك وأسلوبك لمساعدتك في هذا الجانب من التحضير.'
        )}
      </p>
    </div>
  </div>
</div>

      <div
        className="card-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data.map((item) => (
          <NavLink
            to={`/ResumeMaker/temp/${item?.id}`}
            className="hover:no-underline"
          >
            <Card sx={{ maxWidth: 225 }}>
              <CardMedia
                component="img"
                alt="green iguana"
                height="120"
                image={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`}
              />
              <CardContent
                className=" m-0 h-8 pb-3 text-left font-medium"
                style={{ fontFamily: "poppins" }}
              >
                <Typography gutterBottom variant="h8" component="div">
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </NavLink>
        ))}
      </div>
      <NavLink 
      to= "/resumeMaker/temp/Wedding Cards" >
      <Button
        variant="contained"
        onClick={handleOpen}
        className="btn-grad focus:outline-none"
        style={{
          margin: "auto",
          display: "block",
          borderRadius: "20px",
          width: "180px",
          backgroundColor:
            "#882ED8",
        }}
      >
        SHOW MORE
      </Button>
      </NavLink>

      <div className="my-16 text-center">
  <p className="text-[32px] font-[500]">
    {isLang === 'eng' ? (
      'Find beautiful templates for wedding invitations.'
    ) : (
      'الحصول على نماذج جميلة لدعوات الزفاف.'
    )}
  </p>
</div>


      <div className="imageGrid">
        <div>
          <LazyLoadImage src={`${img}`} />
        </div>
        <div>
          <div onClick={() => setImg(`${img1}`)}>
            <LazyLoadImage src={`${img1}`} />
          </div>
          <div onClick={() => setImg(`${img2}`)}>
            <LazyLoadImage src={`${img2}`} />
          </div>
          <div onClick={() => setImg(`${img3}`)}>
            <LazyLoadImage src={`${img3}`} />
          </div>
        </div>
      </div>

      <div className="catelogTextContainer py-5">
  <div className="w-[1000px] gap-4 text-center mx-auto flex flex-col" style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
    {isLang === 'eng' ? (
      <>
        <p style={{ fontSize: "16px" }}>
          Using our online wedding card maker, you can quickly send personalized reservations. You'll save a ton of time and be able to concentrate on the things that really matter.
        </p>
        <p style={{ fontSize: "16px" }}>
          To get started, just select a template from our collection of wedding invitation designs and alter it to your preference. Has the time or date of your venue changed? Not to worry! We will help you to promptly inform your guests. You won't be stressed about it. Are you prepared to begin creating wedding invitations using our online tool?
        </p>
      </>
    ) : (
      <>
        <p style={{ fontSize: "16px" }}>
          باستخدام صانع بطاقات الزفاف الخاص بنا، يمكنك إرسال حجوزات شخصية بسرعة. ستوفر الكثير من الوقت وستكون قادرًا على التركيز على الأشياء المهمة.
        </p>
        <p style={{ fontSize: "16px" }}>
          للبدء، ما عليك سوى اختيار نموذج من مكتبتنا من تصميمات دعوات الزفاف وتعديله حسب تفضيلاتك. هل تغير الوقت أو التاريخ فجأة؟ لا داعي للقلق! سنساعدك على إبلاغ ضيوفك الفوراً. لن تشعر بالتوتر حيال ذلك. هل أنت مستعد للبدء في إنشاء دعوات الزفاف باستخدام أداتنا عبر الإنترنت؟
        </p>
      </>
    )}
  </div>
</div>


<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img33}`} />
  </div>
  <div></div>
  <div style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
    {isLang === 'eng' ? (
      <>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          Create Your Own Wedding Invitations and Save Time and Money
        </p>
        <p style={{ fontSize: "16px" }}>
          Make a good impression, much like on a first date, while sending out
          online wedding invites. The greatest method to get your guests
          excited about your special day is through your invitation! Still, we
          offer a template for everyone, whether you're looking for an
          extroverted, silly invite, or something more subdued. Let your loved
          ones know about the big day by using Maker4U wedding card maker
          without difficulty.
        </p>
      </>
    ) : (
      <>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          أنشئ دعوات الزفاف الخاصة بك ووفّر الوقت والمال
        </p>
        <p style={{ fontSize: "16px" }}>
          اترك انطباعًا جيدًا، كما هو الحال في أول لقاء، أثناء إرسال دعوات الزفاف عبر الإنترنت. أفضل طريقة لإثارة إعجاب ضيوفك بهذا اليوم المميز هي من خلال دعوتك! لذلك، فإننا نقدم نماذج تناسب الجميع، سواء كنت تبحث عن دعوة صاخبة، ساذجة أو شيء أكثر هدوءاً. قم بإعلام أحبائك عن اليوم الكبير باستخدام صانع بطاقات الزفاف Maker4U بسهولة.
        </p>
      </>
    )}
  </div>
</div>


<div className="catlogSectionTwo">
  <div>
    <LazyLoadImage src={`${img66}`} className="w-full h-full px-4" />
  </div>
  <div></div>
  <div style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
    {isLang === 'eng' ? (
      <>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          Wedding invites that go beyond online communication
        </p>
        <p style={{ fontSize: "16px" }}>
          There's nothing more romantic than telling your love story in flair
          on your special day. We encourage you to go above and above by
          making an enjoyable and thrilling wedding slideshow. You should take
          some time to send thank-you cards to your guests after the party is
          over and the knot has been tied. Maker4U is just what you require.
        </p>
      </>
    ) : (
      <>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          دعوات الزفاف التي تتجاوز حدود التواصل عبر الإنترنت
        </p>
        <p style={{ fontSize: "16px" }}>
          لا يوجد ما هو أكثر رومانسية من رواية قصة حبك بأسلوب أنيق في يومك المميز. نحن نشجعك على المضي قدماً من خلال تقديم عرض شرائح زفاف ممتع ومثير. يجب أن تأخذ بعض الوقت لإرسال بطاقات شكر لضيوفك بعد انتهاء الحفلة وعقد القران. إن Maker4U هو ما تحتاجه بالضبط.
        </p>
      </>
    )}
  </div>
</div>

<div className="catelogAITexContainer">
  <div className="catelogAIText" style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
    {isLang === 'eng' ? (
      <>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          Wedding Invitations Made Easy with Maker4U!
        </p>
        <p style={{ fontSize: "16px" }}>
          Maker4U's free wedding invitation constructor offers hundreds of
          professionally designed wedding invitation templates to select from,
          so explore until you find one that suits your big day's aesthetics,
          then start customizing with fonts, icons, and more.
        </p>
      </>
    ) : (
      <>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          دعوات الزفاف أصبحت سهلة مع Maker4U!
        </p>
        <p style={{ fontSize: "16px" }}>
          يوفر مُنشئ دعوات الزفاف المجاني من Maker4U المئات من نماذج دعوات الزفاف المصممة بشكل احترافي للاختيار من بينها، لذا استكشف حتى تجد النموذج الذي يناسب جماليات يومك المميز، ثم ابدأ في التخصيص باستخدام الخطوط والأيقونات والمزيد.
        </p>
      </>
    )}
  </div>
</div>

<div className="cardContainer">
  <div className="step">
    <div className="imageContainer">
      <LazyLoadImage src={`${img7}`} />
    </div>
    <div className="textContent" style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
      {isLang === 'eng' ? (
        <>
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>1. Pick Out a Template</p>
          <p style={{ fontFamily: "poppins", fontWeight: "400", fontSize: "16px" }}>
            Start by selecting from a wide range of templates that suit various themes and styles. The general style and feel of your invitation are established at this phase.
          </p>
        </>
      ) : (
        <>
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>اختر نموذج</p>
          <p style={{ fontFamily: "poppins", fontWeight: "400", fontSize: "16px" }}>
            ابدأ بالاختيار من بين مكتبة واسعة من النماذج التي تناسب مختلف السمات والأنماط. يتم تحديد الأسلوب العام والمظهر العام لدعوتك في هذه المرحلة.
          </p>
        </>
      )}
    </div>
  </div>

  <div className="step">
    <div className="imageContainer">
      <LazyLoadImage src={`${img8}`} />
    </div>
    <div className="textContent" style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
      {isLang === 'eng' ? (
        <>
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>2. Tailor Design Components</p>
          <p style={{ fontFamily: "poppins", fontWeight: "400", fontSize: "16px" }}>
            Customize the selected template by changing different design elements. Enter the venue, date, time, and any other instructions you would like your guests to know about your wedding.
          </p>
        </>
      ) : (
        <>
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>خصص مكونات التصميم</p>
          <p style={{ fontFamily: "poppins", fontWeight: "400", fontSize: "16px" }}>
            قم بتخصيص النموذج المحدد عن طريق تغيير عناصر التصميم المختلفة. أدخل المكان والتاريخ والوقت وأي تعليمات أخرى تريد أن يعرفها ضيوفك عن حفل الزفاف الخاص بك.
          </p>
        </>
      )}
    </div>
  </div>

  <div className="step">
    <div className="imageContainer">
      <LazyLoadImage src={`${img9}`} />
    </div>
    <div className="textContent" style={{ textAlign: isLang === 'eng' ? 'left' : 'right' }}>
      {isLang === 'eng' ? (
        <>
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>3. Export it</p>
          <p style={{ fontFamily: "poppins", fontWeight: "400", fontSize: "16px" }}>
            Save the details and export them to your computer.
          </p>
        </>
      ) : (
        <>
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>تصديرها</p>
          <p style={{ fontFamily: "poppins", fontWeight: "400", fontSize: "16px" }}>
            احفظ التفاصيل وقم بتصديرها إلى جهاز الكمبيوتر الخاص بك.
          </p>
        </>
      )}
    </div>
  </div>
</div>

      <Footer />
    </>
  );
};

export default Weddingcards;
